module.exports = __webpack_public_path__ + "static/media/sfondo-home.e946a04d.jpg";